import React, { createContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

export const ScrollRevealContext = createContext(true);

const RevealFrame = styled.div`
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: ${({ $visible }) => ($visible ? 'translateY(0) scale(1)' : 'translateY(32px) scale(0.985)')};
  filter: ${({ $visible }) => ($visible ? 'blur(0)' : 'blur(4px)')};
  transition: opacity 320ms ease, transform 320ms cubic-bezier(0.2, 0.75, 0.25, 1), filter 320ms ease;

  &[data-active='false'] * { animation: none !important; }

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
    filter: none;
    transition: none;

    * {
      animation: none !important;
      transition: none !important;
    }
  }
`;

const ScrollReveal = ({ children, className }) => {
  const frameRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const frame = frameRef.current;
    if (!frame || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      setActive(true);
      return undefined;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
      setActive(entry.isIntersecting && entry.intersectionRatio > 0);
    }, { threshold: 0, rootMargin: '0px' });

    observer.observe(frame);
    return () => observer.disconnect();
  }, []);

  return (
    <ScrollRevealContext.Provider value={active}>
      <RevealFrame ref={frameRef} className={className} $visible={visible} data-visible={visible} data-active={active}>
        {children}
      </RevealFrame>
    </ScrollRevealContext.Provider>
  );
};

export default ScrollReveal;
